module.exports = __webpack_public_path__ + "img/resource-tech-image-15.3da760da.jpg";